import Grid from '@mui/material/Grid';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import BoxSeparator from '../../components/BoxSeperator/BoxSeparator';
import BottomNavigationBar from '../../components/Layouts/BottomNavigationBar/BottomNavigationBar';
import Footer from '../../components/Layouts/Footer/Footer';
import LayoutSingleColumn from '../../components/Layouts/LayoutSingleColumn';
import LayoutWrapperBottombar from '../../components/Layouts/LayoutWrapperBottombar/LayoutWrapperBottombar';
import LayoutWrapperFooter from '../../components/Layouts/LayoutWrapperFooter/LayoutWrapperFooter';
import LayoutWrapperMain from '../../components/Layouts/LayoutWrapperMain';
import LayoutWrapperTopbar from '../../components/Layouts/LayoutWrapperTopbar/LayoutWrapperTopbar';
import Page from '../../components/Page/Page';
import SectionActivitiesMaybeLoadingSkeleton from './SectionActivities/SectionActivitiesMaybe.skeleton';
import SectionAmenitiesMaybeLoadingSkeleton from './SectionAmenities/SectionAmenitiesMaybe.skeleton';
import SectionDescriptionMaybeLoadingSkeleton from './SectionDescription/SectionDescriptionMaybe.skeleton';
import SectionHeadingLoadingSkeleton from './SectionHeading/SectionHeading.skeleton';
import SectionImagesLoadingSkeleton from './SectionImages/SectionImages.skeleton';
import SectionSurroundingsMaybeLoadingSkeleton from './SectionSurroundings/SectionSurroundingsMaybe.skeleton';
import SectionVehiclesMaybeLoadingSkeleton from './SectionVehicles/SectionVehiclesMaybe.sekelton';

/**
 * This component is shown while the listing data is loading.
 * @param {object} props
 * @param {React.JSX.Element} props.topbar - TopBar component.
 * @returns {React.JSX.Element}
 */

const ListingPageLoadingComponent = ({ topbar }) => {
  const intl = useIntl();

  const loadingTitle = intl.formatMessage({
    id: 'ListingPage.loadingListingTitle',
  });

  return (
    <Page title={loadingTitle}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <Grid container sx={{ backgroundColor: 'white' }}>
            <Grid size={12}>
              <SectionImagesLoadingSkeleton />
            </Grid>
            <Grid size={12}>
              <SectionHeadingLoadingSkeleton />
            </Grid>
            <BoxSeparator />
            <Grid size={12}>
              <SectionDescriptionMaybeLoadingSkeleton />
            </Grid>
            <BoxSeparator />
            <Grid size={12}>
              <SectionAmenitiesMaybeLoadingSkeleton />
              <SectionVehiclesMaybeLoadingSkeleton />
            </Grid>
            <BoxSeparator />
            <Grid size={12}>
              <SectionActivitiesMaybeLoadingSkeleton />
              <SectionSurroundingsMaybeLoadingSkeleton />
            </Grid>
          </Grid>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
        <LayoutWrapperBottombar>
          <BottomNavigationBar />
        </LayoutWrapperBottombar>
      </LayoutSingleColumn>
    </Page>
  );
};

const ListingPageLoading = memo(ListingPageLoadingComponent);
ListingPageLoading.displayName = 'ListingPageLoading';

export default ListingPageLoading;
